import {
  INDUSTRY_OPTIONS,
  POSITION_STATUS_OPTIONS,
  SOURCE_OF_FUNDS_OPTIONS
} from '../shared-constants';

const MONTHLY_VOLUME_OPTIONS = [
  { value: '0_25000', label: '$0 – $25,000' },
  { value: '25000_100000', label: '$25,000 – $100,000' },
  { value: 'above_100000', label: '$100,000 – Above' }
];

const ID_TYPE_OPTIONS = [
  { value: 'international_passport', label: 'International Passport' },
  { value: 'drivers_license', label: "Driver's License" },
  { value: 'national_id', label: 'National Identity Card' }
];

const PEP_POSITION_OPTIONS = [
  { value: 'director', label: 'Director' },
  { value: 'shareholder', label: 'Shareholder' },
  { value: 'ubo', label: 'Ultimate Beneficial Owner' },
  { value: 'employee', label: 'Employee' }
];

const PEP_RELATIONSHIP_OPTIONS = [
  { value: 'self', label: 'Self' },
  { value: 'spouse', label: 'Spouse' },
  { value: 'parent', label: 'Parent' },
  { value: 'child', label: 'Child' },
  { value: 'sibling', label: 'Sibling' },
  { value: 'close_associate', label: 'Close Associate' },
  { value: 'others', label: 'Others (Please specify)' }
];

const CORP_STEPS_STANDARD = [
  { id: 1, label: 'Business Details' },
  { id: 2, label: 'Ownership Structure' },
  { id: 3, label: 'PEP Declaration' },
  { id: 4, label: 'Company Registration & Compliance Docs' }
];

const CORP_STEPS_DNFI = [
  { id: 1, label: 'Business Details' },
  { id: 2, label: 'Ownership Structure' },
  { id: 3, label: 'PEP Declaration' },
  { id: 4, label: 'Company Registration & Compliance Docs' },
  { id: 5, label: 'Due Diligence Questionnaire' }
];

const DNFI_INDUSTRY_VALUES = INDUSTRY_OPTIONS.filter((o) => o.dnfi).map((o) => o.value);

const isDNFIIndustry = (industryValue) => DNFI_INDUSTRY_VALUES.includes(industryValue);

export {
  CORP_STEPS_DNFI,
  CORP_STEPS_STANDARD,
  DNFI_INDUSTRY_VALUES,
  ID_TYPE_OPTIONS,
  INDUSTRY_OPTIONS,
  isDNFIIndustry,
  MONTHLY_VOLUME_OPTIONS,
  PEP_POSITION_OPTIONS,
  PEP_RELATIONSHIP_OPTIONS,
  POSITION_STATUS_OPTIONS,
  SOURCE_OF_FUNDS_OPTIONS
};
